import { Avatar, Box, Tab, Tabs, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import {
  leftMenuAtom,
  leftTabValueAtom,
  rightMenuAtom,
  rightTabValueAtom,
  tabValueAtom,
} from '_state/signature';
import { leftMenuIcons } from 'assets/leftMenuIcons';
import { rightMenuIcons } from 'assets/rightMenuIcons';
import React from 'react';
import { useLocation } from 'react-router-dom';
import { useRecoilState, useRecoilValue } from 'recoil';
import { LeftTabValue, RightTabValue } from '../_modal/signatureModal';
import Header from './header';

type LayoutProps = {
  children: React.ReactNode;
};

type StyledTabsProps = {
  children?: React.ReactNode;
  value: LeftTabValue | RightTabValue;
  onChange: (event: React.SyntheticEvent, newValue: LeftTabValue | RightTabValue) => void;
  borderstyle: Object;
};

const StyledTabs = styled((props: StyledTabsProps) => (
  <Tabs
    TabIndicatorProps={{
      style: { display: 'none' },
    }}
    // TabIndicatorProps={{ children: <span className="MuiTabs-indicatorSpan" /> }}
    orientation="vertical"
    scrollButtons={false}
    sx={{
      '& button:not(.Mui-selected):hover': { background: '#F7F7F7' },
      '& button': {
        color: '#000000 !important',
        width: 56,
        minHeight: 66,
        flex: 0,
        padding: '6px 8px',
        margin: '6px 8px',
        borderRadius: '8px',
      },
      // '& .Mui-selected': { background: '#F7F7F7', color: '#FF8140 !important' },
      '& .Mui-selected': { background: '#FFD19B' },
      height: '100%',
      '& .MuiTabs-flexContainer': {
        height: '100%',
        ...props.borderstyle,
      },
    }}
    {...props}
  />
))({
  // '& .MuiTabs-flexContainer': {
  //   borderRight: '.5px solid #C4C4C4',
  // },
  '& .MuiTabs-indicator': {
    backgroundColor: '#FF8140;',
  },
  // '& .MuiTabs-indicator': {
  //   display: 'flex',
  //   justifyContent: 'center',
  //   backgroundColor: 'transparent',
  // },
  // '& .MuiTabs-indicatorSpan': {
  //   maxWidth: '99%',
  //   width: '100%',
  //   backgroundColor: '#F9FAFD',
  // },
});

// const tabs = [
//   {
//     value: 'Email Signature',
//     icon: 'personal-card',
//   },
//   {
//     value: 'Virtual Background',
//     icon: 'video',
//   },
// ];

const leftTabs = [
  {
    value: 'Templates',
    icon: 'templates',
  },
  {
    value: 'Text',
    icon: 'text',
  },
  {
    value: 'Photos',
    icon: 'photos',
  },
  {
    value: 'Backgrounds',
    icon: 'backgrounds',
  },
];

const rightTabs = [
  {
    value: 'Colors',
    icon: 'colors',
  },
  {
    value: 'Design',
    icon: 'design',
  },
];

function Layout(props: LayoutProps) {
  const location = useLocation();
  // const navigate = useNavigate();

  const tabValue = useRecoilValue(tabValueAtom);
  const [leftTabValue, setLeftTabValue] = useRecoilState(leftTabValueAtom);
  const [rightTabValue, setRightTabValue] = useRecoilState(rightTabValueAtom);
  const [leftMenu, setLeftMenu] = useRecoilState(leftMenuAtom);
  const [rightMenu, setRightMenu] = useRecoilState(rightMenuAtom);

  // const handleChange = (event: React.SyntheticEvent, newValue: TabValue) => {
  //   setTabValue(newValue);
  //   navigate(`${newValue === 'Email Signature' ? '/email-signature' : '/v-card'}`);
  // };

  const handleChangeLeftTab = (
    event: React.SyntheticEvent,
    newValue: LeftTabValue | RightTabValue,
  ) => {
    setLeftTabValue(newValue as LeftTabValue);
  };
  const handleChangeRightTab = (
    event: React.SyntheticEvent,
    newValue: RightTabValue | LeftTabValue,
  ) => {
    setRightTabValue(newValue as RightTabValue);
  };

  return (
    <>
      <Header />
      <section className="layout">
        <Box display={'flex'}>
          {['/', '/email-signature', '/v-card'].includes(location.pathname) ? (
            <Box>
              <StyledTabs
                value={leftTabValue}
                onChange={handleChangeLeftTab}
                aria-label="left styled tabs"
                borderstyle={{ borderRight: '.5px solid #C4C4C4' }}
              >
                {leftTabs.map(tab => {
                  if (tab.value === 'Backgrounds' && tabValue === 'Email Signature') return '';
                  return (
                    <Tab
                      onClick={() => {
                        if (!leftMenu) setLeftMenu(true);
                        if (rightMenu) setRightMenu(false);
                      }}
                      key={tab.value}
                      value={tab.value}
                      label={
                        <Box textTransform={'none'}>
                          <Typography variant="body2" color={'inherit'}>
                            {tab.value}
                          </Typography>
                        </Box>
                      }
                      icon={
                        <Avatar
                          sx={{ width: 24, height: 24, margin: '0' }}
                          variant="square"
                          alt=""
                          src={leftMenuIcons[`${tab.icon}.svg`]}
                          // src={menuIcons[`${tab.icon}${tabValue === tab.value ? '-active' : ''}.svg`]}
                        />
                      }
                    />
                  );
                })}
              </StyledTabs>
            </Box>
          ) : null}
          <Box flex={1} className="container-fluid h-100 p-0">
            {props.children}
          </Box>
          {['/', '/email-signature', '/v-card'].includes(location.pathname) ? (
            <Box>
              <StyledTabs
                value={rightTabValue}
                onChange={handleChangeRightTab}
                aria-label="right styled tabs"
                borderstyle={{ borderLeft: '.5px solid #C4C4C4' }}
              >
                {rightTabs.map(tab => (
                  <Tab
                    key={tab.value}
                    value={tab.value}
                    onClick={() => {
                      if (!rightMenu) setRightMenu(true);
                      if (leftMenu) setLeftMenu(false);
                    }}
                    label={
                      <Box textTransform={'none'}>
                        <Typography variant="body2" color={'inherit'}>
                          {tab.value}
                        </Typography>
                      </Box>
                    }
                    icon={
                      <Avatar
                        sx={{ width: 24, height: 24, margin: '0' }}
                        variant="square"
                        alt=""
                        src={rightMenuIcons[`${tab.icon}.svg`]}
                        // src={menuIcons[`${tab.icon}${tabValue === tab.value ? '-active' : ''}.svg`]}
                      />
                    }
                  />
                ))}
              </StyledTabs>
            </Box>
          ) : null}
        </Box>
      </section>
    </>
  );
}

export default Layout;
